'use strict';

export default function parseStampSegment(stampSegment) {
  const isNewDraft = stampSegment === 'new';

  let [uuid, id] = stampSegment.toString().split('-', 2);
  if (!Boolean(id) && /^\d+$/.test(uuid)) {
    id = uuid;
    uuid = null;
  }

  const isStamp = Boolean(id);
  const isServerDraft = !isNewDraft && !isStamp;

  return {
    isNewDraft,
    isServerDraft,
    isDraft: isNewDraft || isServerDraft,
    isStamp,
    stampId: isStamp ? parseInt(id, 10) : null,
    draftUuid: isServerDraft ? uuid : null,
    stampUuid: isStamp ? uuid : null
  };
}


/** WEBPACK FOOTER **
 ** ./utils/parseStampSegment.js
 **/